import React from 'react';
import { SignUpForm } from './SignUp';
import { SignInForm } from './SignIn';
import { MFAVerifyForm } from './MFAVerify';
import { useAuthStore } from '@store/authStore';

export default function Homepage() {

  const { getAuthType } = useAuthStore();
  const authType = getAuthType();

  return (
    <>
      {authType === "signup" && <SignUpForm />}
      
      {authType === "signin" && <SignInForm />}
      
      {authType === "mfa" && <MFAVerifyForm />}
      
    </>
  );
}
